export default "__VITE_ASSET__CJQaZvWl__"